import { createSelector } from '@ngrx/store';
import { AppState } from '../../app.state';
import { IUserInformation } from '../../interfaces/userInformation';

export const selectUserInformation = (state: AppState) => state.userInformation;

export const selectCsoId = createSelector(
  selectUserInformation,
  (state: IUserInformation) => state.lastSelectedOrganizationId,
);

export const selectedCsoName = createSelector(
  selectUserInformation,
  (state: IUserInformation) => state.lastSelectedOrganizationName,
);

export const selectParentOrganizationTree = createSelector(
  selectUserInformation,
  (state: IUserInformation) => state.parentOrganizationTree,
);

export const selectLastSelectedTankQuickFilter = createSelector(
  selectUserInformation,
  (state: IUserInformation) => state.lastSelectedTankQuickFilter,
);
